<template>
  <div>
    <Breadcrumbs primary="Личный кабинет" secondary="Пользователи"/>
    <AccountUsers :allow-users-editing="true" :show-actions-column="true" :allow-setup-restrictions="true"/>
  </div>
</template>

<script>

import AccountUsers from "@shared/components/lk/account-users/account-users.component.vue"

export default {
  name: "Subusers",
  title: "Пользователи",
  components: {AccountUsers}
}
</script>